// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__xId0w","alert":"SettungsInbox_alert__akxR-"};